import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Group, useMantineTheme, Loader, Text, Paper } from '@mantine/core';
import { IconChevronRight, IconX } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, utils } from "../../utils/globalVariables";
import { getPropInSubLevelRole } from "../../utils/globalFunctions";

import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import ActionIconComponent from "../../components/general/ActionIconComponent";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import TeknisiSelectorDrawer from "../../components/utilities/TeknisiSelectorDrawer";

const RekomendasiPenerima = ({ stateData, fnOnChange }) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'rekomendasiPenerima-1',
    })

    const [data, setData] = React.useState({
        submitLoading: false,

        teknisiSelectorShow: false,

        deleteRekomendasiShow: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitData = (object) => {
        setData(d => ({
            ...d,
            submitLoading: true,
            deleteRekomendasiShow: false,
        }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);
        formDT.append('project_teknisi_id', object ? object.id : '');

        axios({
            method: 'post',
            url: BE_API_TWO + '/edit_project_rekomendasi_teknisi_penerima',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false }));

            if (response.data.flag_status === 'isset') {
                fnOnChange(object);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <InputWrapperCustom
                stateLabel={
                    <Group>
                        <Text>{stateData.data.label}</Text>
                        {data.submitLoading && <Loader size="xs" />}
                    </Group>
                }
                stateWithAsterisk={false}
            >
                <Paper
                    sx={(tema) => ({
                        backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7],
                        borderWidth: '1px',
                        borderStyle: 'solid',
                        borderColor: tema.colorScheme === 'light' ? tema.colors.gray[4] : tema.colors.dark[4],
                        cursor: 'pointer',
                    })}

                    onClick={() => {
                        setData(d => ({
                            ...d,
                            teknisiSelectorShow: true
                        }));
                    }}
                >
                    {!stateData.data.value.id &&
                        <Group
                            position="apart"
                            noWrap
                            p="xs"
                        >
                            <Text size='sm'>Pilih Teknisi</Text>
                            <IconChevronRight size="1rem" />
                        </Group>
                    }

                    {stateData.data.value.id &&
                        <Group
                            position="apart"
                            noWrap
                            p="xs"
                        >
                            <Group noWrap>
                                <Text size='sm'>
                                    <Text>
                                        {stateData.data.value.name}
                                    </Text>

                                    <Text size='xs'>
                                        {getPropInSubLevelRole(stateData.data.value.subLevel, 'caption', '-')}
                                    </Text>
                                </Text>
                            </Group>

                            <ActionIconComponent
                                stateVariant='light'
                                stateRadius='xl'
                                stateTitle='Hapus'
                                stateSize='lg'
                                fnOnClick={(e) => {
                                    e.stopPropagation();
                                    setData(d => ({ ...d, deleteRekomendasiShow: true }))
                                }}

                                StateIcon={IconX}
                                stateIconSize='1.125rem'
                                stateIconStrokeWidth={1.25}
                                stateIconStyle={{
                                    color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                                }}
                            />
                        </Group>
                    }
                </Paper>
            </InputWrapperCustom>

            <TeknisiSelectorDrawer
                stateShow={data.teknisiSelectorShow}
                fnShow={() => setData(d => ({ ...d, teknisiSelectorShow: false }))}
                fnOnSelect={(object) => {
                    submitData(object);
                    setData(d => ({ ...d, teknisiSelectorShow: false }));
                }}
                stateData={{
                    isActive: '1',
                    gender: utils.flagAll
                }}
            />

            <ModalTakeAction
                stateShow={data.deleteRekomendasiShow}
                fnHide={() => setData(d => ({ ...d, deleteRekomendasiShow: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Hapus'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.submitLoading}
                fnButtonAction={() => submitData(null)}
            >
                <Text size='sm'>Hapus rekomendasi ?</Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default RekomendasiPenerima;